import React from "react";

import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkStreakEffect {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkStreakEffect: IframeworkStreakEffect = {

    data: {
        "COMPONENTS": [
            {
                "id": "streakContainer",
                "name": "streakContainer",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                child: [
                    {
                        "name": "streak_flash_fx",
                        "type": "Animation",
                        "width": 150,
                        "height": 150,
                        "image": "streak_flash_fx",
                        "animationSpeed": 0.3,
                        "playing": false,
                        "loop": false,
                        "visible": false,
                        "anchor": [0.5, 0.5],
                        "x": 69,
                        "y": 99,
                        "animations": {
                            "anim": "streak_flash_fx",
                        },
                    },

                ]
            },

        ]
    }

};

export const StreakEffectConfigurationContext = React.createContext(
    {}
);